<section class="section white-100" *ngIf="securityData">
    <div class="section-container-inside">
      <h2 class="section-heading mar-b-48">
        {{ securityData?.title }}
      </h2>
      <div class="security-compliance grey-100">
        <div class="security-compliance-content">
          <div class="security-content" *ngFor="let item of securityData.component1">
            <img class="icon-image" [src]="item.fields.imageicon.fields.file.url" alt="" loading="lazy" />
            <div class="security-compliance-heading">
              {{ item.fields.richTextTitle.content[0].content[0].value }}
            </div>
            <div class="security-compliance-description" [innerHTML]="item.fields.description | toHtml"></div>
          </div>
        </div>
        <div class="security-compliance-badges">
          <ng-container *ngFor="let item of securityData.image">
            <img [src]="item.fields.file.url" alt="" loading="lazy" />
          </ng-container>
        </div>
      </div>
    </div>
  </section>